import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import API from "../Services/Report";
import { ToastContainer, toast } from "react-toastify";
import CenterModal from "../Components/CenterSelectorModal";
import * as XLSX from "xlsx";
import moment from "moment";
const SummaryReport = () => {
  const [summary, setSummary] = useState([]);
  const [payment, setPayment] = useState([]);
  const [revenue, setRevenue] = useState([]);
  const [activeReport, setActiveReport] = useState("ledger");
  const [selectedCenter, setSelectedCenter] = useState(null);
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const pastDate = new Date();
  pastDate.setDate(pastDate.getDate() - 90);
  const formattedPastDate = pastDate.toISOString().split("T")[0];
  const [totalCount, setTotalCount] = useState(0);
  const [resetTrigger, setResetTrigger] = useState(0);
  const [search, setSearch] = useState({
    searchText: "",
    from_date: formattedToday,
    to_date: formattedToday,
  });

  // const handleFieldChange = (e, fieldName) => {
  //   const value = e.target.value;
  //   setSearch((prev) => ({
  //     ...prev,
  //     [fieldName]: value,
  //   }));
  // };
  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;

    if (fieldName === "from_date") {
      const newToDate = moment(value).add(90, "days");

      const finalToDate = newToDate.isAfter(moment())
        ? moment().format("YYYY-MM-DD")
        : newToDate.format("YYYY-MM-DD");

      setSearch((prev) => ({
        ...prev,
        from_date: value,
        to_date: finalToDate
      }));
    } else {
      setSearch((prev) => ({
        ...prev,
        [fieldName]: value
      }));
    }
  };

  const handleSelectedCenter = (selectedData) => {
    setSelectedCenter(selectedData);
  };

  useEffect(() => {

    if (activeReport === "ledger") {
      GetLocationAnalyticReport();
    } else if (activeReport === "payment") {
      GetLocationPaymentSummaryReport();
    } else if (activeReport === "finance") {
      GetLocationRevenueSummaryReport();
    }
  }, [activeReport]);

  const GetLocationAnalyticReport = async () => {
    try {
      const centerlist = Array.isArray(selectedCenter)
        ? selectedCenter.join(",")
        : selectedCenter;
      const payload = {
        start_date: search.from_date || formattedPastDate,
        end_date: search.to_date || formattedToday,
        location_id: centerlist || null,
      };

      const response = await API.getLocationAnalyticReport(payload);
      // console.log('rrrrrrrrrrr',response?.data?.result);
      setSummary(response?.data?.result || []);
      setTotalCount(response?.data?.result?.length)
      // console.log('Ledger', response?.data?.result)
    } catch (error) {
      if (error.response?.status === 403) {
        window.location.replace("/Login");
      } else {
        toast.error(
          error.response?.data?.message || "Something went wrong"
        );
      }
    }
  };

  const GetLocationPaymentSummaryReport = async () => {
    try {
      const centerlist = Array.isArray(selectedCenter)
        ? selectedCenter.join(",")
        : selectedCenter;

      const payload = {
        start_date: search.from_date || formattedPastDate,
        end_date: search.to_date || formattedToday,
        location_id: centerlist || null,
      };
      const response = await API.getLocationPaymentSummaryReport(payload);
      setPayment(response?.data?.result)
      setTotalCount(response?.data?.result?.length)
      // console.log('payment', response?.data?.result?.length)
    }

    catch (error) {
      if (error.response?.status === 403) {
        window.location.replace("/Login");
      } else {
        toast.error(
          error.response?.data?.message || "Something went wrong"
        );
      }
    }
  }

  const GetLocationRevenueSummaryReport = async () => {
    try {
      const centerlist = Array.isArray(selectedCenter)
        ? selectedCenter.join(",")
        : selectedCenter;
      const payload = {
        start_date: search.from_date || formattedPastDate,
        end_date: search.to_date || formattedToday,
        location_id: centerlist || null,
      };
      const response = await API.getLocationRevenueSummaryReport(payload);
      setRevenue(response?.data?.result)
      setTotalCount(response?.data?.result?.length)
      // console.log('Finance', response?.data?.result?.length)
    }
    catch (error) {
      if (error.response?.status === 403) {
        window.location.replace("/Login");
      } else {
        toast.error(
          error.response?.data?.message || "Something went wrong"
        );
      }
    }
  }

  const reportTabs = [
    { id: "ledger", label: "Ledger", icon: "mdi mdi-book-open" },
    { id: "finance", label: "Finance", icon: "mdi mdi-chart-line" },
    { id: "payment", label: "Payments", icon: "mdi mdi-currency-rupee" },
  ];

  const handleSearch = () => {
    if (activeReport === "ledger") {
      GetLocationAnalyticReport();
    } else if (activeReport === "payment") {
      GetLocationPaymentSummaryReport();
    } else if (activeReport === "finance") {
      GetLocationRevenueSummaryReport();
    }
  };

  const handleClear = () => {
    setSearch({
      searchText: "",
      // from_date: "",
      // to_date: "",
      from_date: formattedToday,
      to_date: formattedToday,
    });
    setSelectedCenter([]);
    setResetTrigger((p) => p + 1);
  };

  // const downloadCSV = async () => {
  //   try {
  //     const centerlist = Array.isArray(selectedCenter)
  //       ? selectedCenter.join(",")
  //       : selectedCenter;
  //     const payload = {
  //       start_date: search.from_date || formattedPastDate,
  //       end_date: search.to_date || formattedToday,
  //       location_id: centerlist && centerlist.length > 0 ? centerlist : null,
  //     };

  //     let response;
  //     let fileName = "Report";
  //     let result;

  //     if (activeReport === "ledger") {
  //       response = await API.getLocationAnalyticReport(payload);
  //       result = (response?.data?.result)
  //       console.log('ddddd',result);
  //       fileName = "Ledger_Report";
  //     } else if (activeReport === "payment") {
  //       response = await API.getLocationPaymentSummaryReport(payload);
  //       result = (response?.data?.result)
  //       fileName = "Payment_Report";
  //     }
  //     else if (activeReport === "finance") {
  //       response = await API.getLocationRevenueSummaryReport(payload);
  //       result = (response?.data?.result)
  //       fileName = "Finance_Report";
  //     }
  //     if (!result.length) {
  //       toast.error("No data found!");
  //       return;
  //     }

  //     const worksheet = XLSX.utils.json_to_sheet(result);
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  //     XLSX.writeFile(
  //       workbook,
  //       `${fileName}.xlsx`
  //     );
  //   } catch (error) {
  //     console.error("Error downloading Excel:", error);
  //   }
  // };

const downloadCSV = async () => {
  try {
    const centerlist = Array.isArray(selectedCenter)
      ? selectedCenter.join(",")
      : selectedCenter;

    const payload = {
      start_date: search.from_date || formattedPastDate,
      end_date: search.to_date || formattedToday,
      location_id: centerlist && centerlist.length > 0 ? centerlist : null,
    };

    let response;
    let fileName = "Report";
    let result = [];

    if (activeReport === "ledger") {
      response = await API.getLocationAnalyticReport(payload);
      result = response?.data?.result || [];
      fileName = "Ledger_Report";
    } else if (activeReport === "payment") {
      response = await API.getLocationPaymentSummaryReport(payload);
      result = response?.data?.result || [];
      fileName = "Payment_Report";
    } else if (activeReport === "finance") {
      response = await API.getLocationRevenueSummaryReport(payload);
      result = response?.data?.result || [];
      fileName = "Finance_Report";
    }

    if (!result.length) {
      toast.error("No data found!");
      return;
    }

    // Convert all numeric string values to Number
    const excelData = result.map((row) => {
      const newRow = {};

      Object.keys(row).forEach((key) => {
        const value = row[key];

        if (typeof value === "string") {
          const cleaned = value.replace(/,/g, "").trim();

          // Convert only numeric strings
          if (cleaned !== "" && !isNaN(cleaned)) {
            newRow[key] = Number(cleaned);
          } else {
            newRow[key] = value;
          }
        } else {
          newRow[key] = value;
        }
      });

      return newRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    // Apply Excel number format
    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let R = range.s.r + 1; R <= range.e.r; R++) {
      for (let C = range.s.c; C <= range.e.c; C++) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = worksheet[cellRef];

        if (cell && typeof cell.v === "number") {
          cell.t = "n";
          cell.z = "#,##0.00";
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Error downloading Excel:", error);
    toast.error("Error downloading Excel");
  }
};

  const getDynamicHeaders = (data) => {

    if (!data || data.length === 0) return [];
    return Object.keys(data[0]);
  };

  const formatHeader = (text) => {
    if (!text) return "";
    const label =
      text === "location_name"
        ? "Center Name"
        : text
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase());

    return (
      <span style={{ display: "inline-flex", alignItems: "center", gap: "5px" }}>

        {text !== "location_name" && (
          <i className="mdi mdi-currency-rupee"></i>
        )}

        {label}
      </span>
    );
  };

  const formatHeaderLedger = (text) => {
    if (!text) return "";

    return text === "location_name"
      ? "Center Name"
      : text
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const formatValue = (value) => {
    if (typeof value === "number") {
      return value.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    return value ?? "-";
  };

  const columnLedger =
    summary.length > 0
      ? Object.keys(summary[0])
      : [];

  return (
    <div className="container-fluid">
      <ToastContainer />
      <div className="modern-nav-tabs">
        {reportTabs.map((tab) => (
          <label
            key={tab.id}
            style={{ marginRight: "50px" }}
            className={`modern-tab ${activeReport === tab.id ? "active" : ""}`}
          >
            <input
              type="radio"
              name="reportType"
              value={tab.id}
              checked={activeReport === tab.id}
              onChange={() => {
                setActiveReport(tab.id);
                setSelectedCenter([]);
                setSearch({
                  searchText: "",
                  from_date: formattedToday,
                  to_date: formattedToday,
                });
              }}
              hidden
            />
            <i className={tab.icon}></i>
            <span>{tab.label}</span>
          </label>
        ))}
      </div>

      <div className="modern-filter-section mt-3">
        <div className="filter-title">
          <i className="mdi mdi-filter-variant-plus"></i>
          <span>Filter Options</span>
        </div>
        <div className="row mb-3">
          <div className="col-md-5">
            <CenterModal onSelectCenter={handleSelectedCenter} resetTrigger={resetTrigger} key={resetTrigger} />
          </div>

          <div className="col-md-3">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={search.from_date || ""}
              // min={formattedPastDate}
              max={formattedToday}
              onChange={(e) => handleFieldChange(e, "from_date")}
            />
          </div>

          <div className="col-md-3">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              value={search.to_date || ""}
              min={search.from_date}
              max={
                search.from_date
                  ? new Date(
                    Math.min(
                      new Date(search.from_date).setDate(new Date(search.from_date).getDate() + 90),
                      new Date()
                    )
                  ).toISOString().split("T")[0]
                  : formattedToday
              }
              onChange={(e) => handleFieldChange(e, "to_date")}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-2 d-flex align-items-end">
            <button
              onClick={handleSearch}
              className="btn btn-success"
              type="button"
            >
              Search
            </button>
            <button
              onClick={handleClear}
              className="btn btn-secondary ms-3"
              type="button"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title mb-0">{activeReport} Report || Total Count ({totalCount})</h4>

          <button className="btn btn-primary btn-sm" onClick={downloadCSV}>
            <i className="fa fa-download"></i>
          </button>

        </div>
        {activeReport === "ledger" && (
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead className="table-light">
                  <tr>
                    <th>Sr No</th>

                    {columnLedger.map((key, index) => (
                      <th key={index}>
                        {["coin_bought", "package_load_amount"].includes(key) ? (
                          <>
                            <span className="mdi mdi-currency-rupee me-1"></span>
                            {formatHeaderLedger(key)}
                          </>
                        ) : (
                          formatHeaderLedger(key)
                        )}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {summary.length > 0 ? (
                    summary.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        <td>{rowIndex + 1}</td>

                        {columnLedger.map((key, colIndex) => (
                          <td key={colIndex}>
                            {row[key] || "0"}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={columnLedger.length}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {activeReport === "finance" && (
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  {getDynamicHeaders(revenue).map((header) => (
                    <th key={header} style={{ whiteSpace: "nowrap" }}>
                      {formatHeader(header)}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {revenue.length > 0 ? (
                  revenue.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{rowIndex + 1}</td>

                      {getDynamicHeaders(revenue).map((header) => (
                        <td key={header} className="text-end">
                          {formatValue(row[header])}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="50" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        {activeReport === "payment" && (
          <div className="table-responsive">
            <table className="table table-bordered text-center">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  {getDynamicHeaders(payment)
                    .filter((header) => header !== "location_id")
                    .map((header) => (
                      <th key={header} style={{ whiteSpace: "nowrap" }}>
                        {formatHeader(header)}
                      </th>
                    ))}
                </tr>

              </thead>
              <tbody>
                {payment.length > 0 ? (
                  payment.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{rowIndex + 1}</td>
                      {getDynamicHeaders(payment)
                        .filter((header) => header !== "location_id")
                        .map((header) => (
                          <td key={header} className="text-end">
                            {formatValue(row[header])}
                          </td>
                        ))}
                    </tr>

                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>

            </table>

          </div>
        )}

      </div>

    </div>
  );
};

export default SummaryReport;
